import { QUERY_KEYS, soCaiColumns, thanhToanPhaiTraColumns, theKhoColumns, thueVatDauVaoColumns } from '@/constants';
import { InfoDropdownV2, type InfoTableItem } from '@/components/custom/erp';

interface InfoProps {
  uuid: string;
  ma_ct?: string;
}

const stockLedgerVisibleFields = [
  'loai_kho',
  'xid',
  'ma_unit',
  'so_ct',
  'ngay_ct',
  'ma_kho',
  'ma_vt',
  'ten_vt',
  'ma_kh',
  'ma_nt',
  'px_dd',
  'pn_tb',
  'gia',
  'sl_nhap',
  'tien_nhap',
  'thue',
  'ma_bp',
  'ma_ct'
];

const tableItems: InfoTableItem[] = [
  {
    title: 'Xem sổ kho mua/bán hàng',
    endpoint: QUERY_KEYS.SO_KHO,
    columns: theKhoColumns,
    visibleFields: stockLedgerVisibleFields,
    group: 1
  },
  { title: 'Xem sổ cái', endpoint: QUERY_KEYS.SO_CAI, columns: soCaiColumns, group: 1 },
  {
    title: 'Thanh toán phải trả',
    endpoint: QUERY_KEYS.THANH_TOAN_PHAI_TRA,
    columns: thanhToanPhaiTraColumns,
    group: 1
  },
  { title: 'Thuế VAT đầu vào', endpoint: QUERY_KEYS.THUE_VAT_DAU_VAO, columns: thueVatDauVaoColumns, group: 1 }
];

const InfoDropdown = ({ uuid, ma_ct }: InfoProps) => (
  <InfoDropdownV2 uuid={uuid} ma_ct={ma_ct} tableItems={tableItems} />
);

export default InfoDropdown;
